import { BehaviorSubject } from 'rxjs';
export class Observables {
	static registrationData$ = new BehaviorSubject(null);
	static investorSummaryRefresh = new BehaviorSubject(0);
}
